export default __webpack_public_path__ + "static/media/undraw-high-five.1fd15681.svg";